import {CartPink, HomePink} from '../components/Icons'

// This page generates no HTML, as that's all handled in the 3D scene, which is handled separately.
// all this component provides is handlers for the objectClicked events that come out of the 
// 3D scene.

export function SubRoom(props) {

  /*React.useEffect(() => {
    window.addEventListener('objectClicked', (event) => {
      console.log(`Sub-Room.  Object clicked event ${event.detail}`)

      switch (event.detail) {

        case 'exitDoor':
          props.updatePage(constants.REACT_PAGE_MAIN)
          break

        default:
          console.log(`Sub-Room unexpected event ${event.detail}`)
          break
      }
    })
  })*/


  // Just show top of page icons...        
  return (
    <>
      <HomePink updatePage={props.updatePage}/>
      <CartPink updatePage={props.updatePage}
                itemCount={props.itemCount}
                cartIconStatus = {props.cartIconStatus}/>
      {/*<LookAroundPrompt/>*/}
    </>
  )
}